import React from 'react';
import { useParams } from 'react-router';
import i18n from '../../utilities/i18n';
import AccountHeader from './accountComponents/AccountHeader';
import { useQuery } from '@tanstack/react-query';
import { LoadingSpinner, VStack } from '@adc/parallax-component-library';
import { accountQueryOptions } from '../../queryOptions';
import MessageBanner from '../messageBanner/MessageBanner';

export function Account() {
  const { accountKey } = useParams();

  const account = useQuery(accountQueryOptions({ key: accountKey }));

  return (
    <VStack gap={'$4'} height={'100%'}>
      {account.isPending ? (
        <VStack alignItems="center" justifyContent="center" flexGrow={1}>
          <LoadingSpinner testID="account-loading-spinner" />
        </VStack>
      ) : null}

      {account.isError ? (
        <MessageBanner
          type="danger"
          headerText={i18n.t('Page_Account.load_error_title')}
          bodyText={i18n.t('Page_Account.load_error')}
        />
      ) : null}

      {account.isSuccess ? <AccountHeader account={account.data} /> : null}
    </VStack>
  );
}
